module.exports = __webpack_public_path__ + "static/img/4.829c744d.png";